import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import CookieConsent from "./Components/CookieConsent/CookieConsent";
import RouteSeo from "./Components/Seo/RouteSeo";
import Home from "./Pages/Home/Home";
import Contacts from "./Pages/Contacts/Contacts";
import Admin from "./Pages/Admin/Admin";
import PrivacyPolicy from "./Pages/Legal/PrivacyPolicy";
import TermsConditions from "./Pages/Legal/TermsConditions";
import WomanPage from "./Pages/WomanPage/WomanPage";
import About from "./Pages/About/About";
import NewsListPage from "./Pages/News/NewsListPage";
import NewsDetailPage from "./Pages/News/NewsDetailPage";
import DirectoryPage from "./Pages/Directory/DirectoryPage";
import TaxonomyPage from "./Pages/Directory/TaxonomyPage";
import NotFound from "./Pages/NotFound/NotFound";
import { HomeProvider } from "./context/HomeContext";
import StickyAd from "./Components/StickyAd/StickyAd";
import { stripLanguageFromPath, useLanguage } from "./i18n/LanguageProvider";
import "./App.sass";

function LegacyNewsRedirect() {
    const { language } = useLanguage();
    const { slug } = useParams();
    const target = slug ? `/${language}/noutati/${slug}` : `/${language}/noutati`;

    return <Navigate to={target} replace />;
}

function App() {
    const location = useLocation();
    const { language } = useLanguage();
    const localizedPathname = stripLanguageFromPath(location.pathname);
    const showHero = localizedPathname === "/";
    const isAdmin = localizedPathname === "/admin";

    return (
        <HomeProvider>
            <RouteSeo />
            {!isAdmin && <Header showHero={showHero} />}

            <Routes>
                <Route path="/:lang" element={<Home />} />
                <Route path="/:lang/noutati" element={<NewsListPage />} />
                <Route path="/:lang/noutati/:slug" element={<NewsDetailPage />} />
                <Route path="/:lang/stiri" element={<LegacyNewsRedirect />} />
                <Route path="/:lang/stiri/:slug" element={<LegacyNewsRedirect />} />
                <Route path="/:lang/femeie/:slug" element={<WomanPage />} />
                <Route path="/:lang/femei" element={<DirectoryPage />} />
                <Route path="/:lang/categorie/:slug" element={<TaxonomyPage type="category" />} />
                <Route path="/:lang/tara/:slug" element={<TaxonomyPage type="place" />} />
                <Route path="/:lang/despre-noi" element={<About />} />
                <Route path="/:lang/contact" element={<Contacts />} />
                <Route path="/:lang/contacte" element={<Navigate to={`/${language}/contact`} replace />} />
                <Route path="/:lang/admin" element={<Admin />} />
                <Route
                    path="/:lang/confidentialitate"
                    element={<Navigate to={`/${language}/politica-de-confidentialitate`} replace />}
                />
                <Route path="/:lang/politica-de-confidentialitate" element={<PrivacyPolicy />} />
                <Route path="/:lang/termeni" element={<Navigate to={`/${language}/termeni-si-conditii`} replace />} />
                <Route path="/:lang/termeni-si-conditii" element={<TermsConditions />} />
                <Route path="*" element={<NotFound />} />
            </Routes>

            {!isAdmin && <Footer />}
            {!isAdmin && <CookieConsent />}
            {!isAdmin && <StickyAd />}
        </HomeProvider>
    );
}

export default App;
